import { create } from 'axios';
import queryString from 'query-string';

import { WARP_MERCHANT_STORAGE_KEY } from '../constants';

export const authApiAgent = create({
  baseURL: import.meta.env.VITE_AUTH_API_URI,
});

export const gatewayApiAgent = create({
  baseURL: import.meta.env.VITE_WM_GATEWAY_URI,
  headers: { 'X-App-Version': __SHORT_VERSION_HASH__ },
  paramsSerializer: { serialize: (params) => queryString.stringify(params) },
  transitional: { silentJSONParsing: false, clarifyTimeoutError: true },
  // 0 is the default and sets the timeout to infinity
  // however, a timeout of 30s is set in Cloudfront
  timeout: 0,
});

gatewayApiAgent.interceptors.request.use(
  async (config) => {
    let merchantId = null;
    try {
      const merchant = localStorage.getItem(WARP_MERCHANT_STORAGE_KEY);
      merchantId = merchant ? JSON.parse(merchant)?.id : null;
    } catch (e) {
      merchantId = null;
      console.error('WARP Merchant ID is not available in localStorage', e);
    }
    if (merchantId) {
      config.headers['X-Warp-Merchant-Id'] = merchantId;
    }
    return config;
  },
  (error) => {
    console.error('Request configuration error: ', error);
    return Promise.reject(error);
  },
);

export const assetRepositoryApiAgent = create({
  baseURL: import.meta.env.VITE_ASSET_REPOSITORY_SERVICE_URI,
});
